import React from 'react';
import {FAQItem} from '../../../types';

export const faqItems: FAQItem[] = [
  {
    id: '1',
    question: 'Общие принципы работы с личным кабинетом',
    answer: (
      <>
        <p>
          Личный кабинет (ЛК) предоставляется потенциальному заемщику после прохождения быстрой
          регистрации. Создание личного кабинета является бесплатным и не налагает на пользователя
          никаких обязательств.
        </p>
        <p>
          Личный кабинет – это основной рабочий интерфейс взаимодействия заемщика с Платформой.
          Через него осуществляется вся работа по подготовке и сопровождению сделки.
        </p>
        <p>В личном кабинете доступны следующие возможности:</p>
        <ul>
          <li>ознакомление с продуктами Платформы;</li>
          <li>доступ к типовым документам по сделкам;</li>
          <li>прохождение процедуры верификации;</li>
          <li>подача заявок на привлечение финансирования;</li>
          <li>коммуникация с персональным менеджером Платформы.</li>
        </ul>
        <p>
          После размещения заявки и получения финансирования личный кабинет становится рабочим
          инструментом для финансовой службы заемщика.
        </p>
        <p>В личном кабинете будут доступны:</p>
        <ul>
          <li>вся переписка и коммуникация с менеджерами Платформы;</li>
          <li>полный комплект документов по сделке;</li>
          <li>
            реестр кредиторов, участвующих в финансировании, с указанием их налоговых статусов и
            объема инвестиций;
          </li>
          <li>график погашения обязательств;</li>
          <li>
            транзакционная выписка по поступлению средств на номинальный счет и их распределению
            между кредиторами;
          </li>
          <li>
            возможность формирования инвойсов на дату платежа с расчетом всех финансовых и
            налоговых показателей для бухгалтерии заемщика.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: '2',
    question: 'Что такое пре-скоринг и зачем он нужен?',
    answer: (
      <>
        <p>
          Пре-скоринг – это предварительная автоматическая проверка заемщика и предмета обеспечения
          по базовым стоп-факторам. Это не является полноценной процедурой скоринга.
        </p>
        <p>
          Пре-скоринг используется для первичной оценки параметров потенциальной сделки и позволяет
          на раннем этапе определить:
        </p>
        <ul>
          <li>соответствует ли заемщик базовым требованиям Платформы;</li>
          <li>
            может ли заявленная дебиторская задолженность рассматриваться в качестве обеспечения.
          </li>
        </ul>
        <p>
          Таким образом система позволяет сократить время рассмотрения заявки и выявить возможные
          ограничения еще до начала полноценного анализа сделки.
        </p>
        <p>
          В рамках пре-скоринга вы можете загрузить данные нескольких ваших контрагентов (ИНН).
          Система автоматически покажет, дебиторская задолженность каких из них может
          использоваться в качестве обеспечения по сделке привлечения финансирования.
        </p>
        <p>Пре-скоринг является обязательным этапом. Он может быть проведен:</p>
        <ul>
          <li>через электронную форму в личном кабинете;</li>
          <li>через персонального менеджера Платформы – для крупных или постоянных клиентов.</li>
        </ul>
      </>
    ),
  },
  {
    id: '3',
    question: 'Бесплатные скоринговые проверки – это часть заявки?',
    answer: (
      <>
        <p>Нет. Бесплатные скоринговые проверки не связаны с подачей заявки на финансирование.</p>
        <p>
          Это отдельный сервис, предоставляемый системой Rescore. Rescore (входит в Группу Кономика)
          – это автоматическая скоринговая платформа, которая агрегирует данные о компаниях и
          используется банками и крупными корпоративными клиентами для проверки контрагентов и
          мониторинга их финансового состояния.
        </p>
        <p>Размещение формы проверки контрагентов в личном кабинете выполняет две функции:</p>
        <ul>
          <li>Для Платформы – это демонстрация возможностей системы Rescore.</li>
          <li>Для пользователя – возможность бесплатно проверить своих контрагентов.</li>
        </ul>
        <p>Каждому пользователю предоставляется 100 бесплатных проверок.</p>
        <p>
          После исчерпания лимита бесплатные проверки прекращаются. При необходимости пользователь
          может подключить платную версию сервиса.
        </p>
        <p>
          В бесплатной версии отчеты формируются в формате PDF и направляются в раздел
          «Уведомления» личного кабинета.
        </p>
        <p>
          В платных версиях отчеты могут поступать через AI-бот напрямую на телефон финансового
          директора или аналитика.
        </p>
      </>
    ),
  },
  {
    id: '4',
    question: 'Зачем требуется верификационная анкета?',
    answer: (
      <>
        <p>
          Заполнение верификационной анкеты является обязательным требованием законодательства.
        </p>
        <p>
          Платформа работает на основании лицензии Банка России и включена в Реестр операторов
          инвестиционных платформ ЦБ РФ. В связи с этим Платформа обязана проводить идентификацию
          участников электронного документооборота и проверку предоставленных ими данных.
        </p>
        <p>
          Верификационная анкета используется для подтверждения сведений о заемщике и допуска к
          дальнейшей работе на Платформе.
        </p>
      </>
    ),
  },
  {
    id: '5',
    question: 'Где можно ознакомиться с требованиями к скорингу и типовыми документами?',
    answer: (
      <>
        <p>
          В верхней части личного кабинета размещен сквозной блок этапов работы с заявкой. В нем
          доступны следующие разделы:
        </p>
        <ul>
          <li>Шаг 3 – перечень документов, необходимых для проведения полного скоринга.</li>
          <li>Шаг 4 – образцы типовых документов, используемых при оформлении сделки.</li>
        </ul>
        <p>
          Для перехода к соответствующему разделу достаточно нажать на виджет нужного этапа.
        </p>
      </>
    ),
  },
  {
    id: '6',
    question: 'В чем отличие регрессной и безрегрессной модели финансирования?',
    answer: (
      <>
        <p>
          <strong>Регрессная модель</strong>
        </p>
        <p>
          В рамках регрессной модели осуществляется уступка права требования к вашему контрагенту.
          Контрагент производит оплату в адрес Платформы, и сумма вашей задолженности перед
          инвесторами уменьшается на размер полученных средств.
        </p>
        <p>
          Если контрагент не исполняет свои обязательства, обязанность по возврату средств
          инвесторам сохраняется за заемщиком. По своей экономической сути эта модель аналогична
          банковскому регрессному факторингу.
        </p>
        <p>
          <strong>Безрегрессная модель</strong>
        </p>
        <p>
          В безрегрессной модели требование к контрагенту передается Платформе в качестве
          отступного. Возврат средств инвесторам осуществляется исключительно за счет денежных
          средств, полученных от контрагента. По своей структуре такая модель близка к
          безрегрессному факторингу.
        </p>
      </>
    ),
  },
  {
    id: '7',
    question: 'Могут ли итоговые договоры отличаться от типовых форм?',
    answer: (
      <>
        <p>
          Платформа работает под регулированием Банка России, поэтому формы основных договоров
          являются типовыми и согласованы с регулятором. Документы, непосредственно связанные с
          привлечением инвестиций, не подлежат изменению.
        </p>
        <p>В рамках подготовки сделки согласовываются только индивидуальные условия, включая:</p>
        <ul>
          <li>процентную ставку;</li>
          <li>вид обеспечения;</li>
          <li>параметры обеспечения.</li>
        </ul>
        <p>
          При необходимости Платформа может запросить дополнительные заверения об обстоятельствах,
          связанных с обеспечением сделки.
        </p>
      </>
    ),
  },
  {
    id: '8',
    question: 'Как происходит согласование документов?',
    answer: (
      <>
        <p>
          После успешного прохождения скоринга в личном кабинете появится уведомление о готовности
          пакета документов.
        </p>
        <p>Предварительные документы направляются:</p>
        <ul>
          <li>в раздел «Уведомления» личного кабинета;</li>
          <li>на электронную почту, указанную при регистрации.</li>
        </ul>
        <p>Обсуждение параметров сделки может происходить:</p>
        <ul>
          <li>через форму обратной связи в личном кабинете;</li>
          <li>напрямую с персональным менеджером.</li>
        </ul>
      </>
    ),
  },
  {
    id: '9',
    question: 'Как подписываются документы?',
    answer: (
      <>
        <p>
          Подписание документов осуществляется с использованием усиленной квалифицированной
          электронной подписи (УКЭП). Подписание производится через систему электронного
          документооборота Контур.Диадок.
        </p>
        <p>
          Ссылка-приглашение для подписания документов направляется в личный кабинет и на
          электронную почту пользователя.
        </p>
      </>
    ),
  },
  {
    id: '10',
    question: 'Когда заявка размещается на Платформе?',
    answer: (
      <>
        <p>
          Срок размещения заявки согласовывается с заемщиком и указывается в оферте в разделе
          «Начало действия оферты».
        </p>
        <p>
          Как правило, размещение происходит в течение трех дней после подписания документов, однако
          при необходимости возможно размещение в тот же день.
        </p>
      </>
    ),
  },
  {
    id: '11',
    question: 'Когда заемщик получает денежные средства?',
    answer: (
      <>
        <p>
          В соответствии с законодательством Платформа обязана перечислить заемщику денежные
          средства не позднее трех дней после завершения сбора инвестиций.
        </p>
        <p>Фактический срок зависит от скорости привлечения инвесторов.</p>
        <p>
          Если условия сделки являются привлекательными для инвесторов, сбор средств может быть
          завершен в течение одного дня.
        </p>
      </>
    ),
  },
  {
    id: '12',
    question: 'Можно ли размещать повторные заявки?',
    answer: (
      <>
        <p>Да. Повторное размещение заявок возможно после прохождения нового скоринга.</p>
      </>
    ),
  },
];
